import configuration from '@/services/user-manager/user-manager-configuration';
import { User, UserManager } from 'oidc-client';

const userManager = new UserManager(configuration);

userManager.events.addUserLoaded((user: User) => {
    // TODO(Dan): Store relevent info into the store.
    // TODO(Dan): Do we need to reload permissions!
});
userManager.events.addUserSignedOut(() => {
    // TODO(Dan): Deal with logout, clear stuff out etc.
    // TODO(Dan): Redirect to login screen!?
});
userManager.events.addSilentRenewError((error: any) => {
    // TODO(Dan): What do we want to do here?
});

export default userManager;
